import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../refeicao.module.css";
import BottomNav from "../../../components/BottomNav";
import BackIcon from "../../../components/BackIcon";
import api from "../../../services/api";
import { AuthContext } from "../../../context/AuthContext";
import ApiButton from "../../../components/ApiButton/ApiButton";

const diasSemana = [
    { id: 1, nome: "Segunda" },
    { id: 2, nome: "Terça" },
    { id: 3, nome: "Quarta" },
    { id: 4, nome: "Quinta" },
    { id: 5, nome: "Sexta" }
];

// Textos exatos pedidos pelo usuário (2026-10-15) pra gravar no campo
// "nompra" (mesmo campo que o almoço usa pra "alteração de prato") -
// precisam ser usados literalmente, não é só um rótulo de exibição.
function obterNompraCafe(temPao, temFruta) {
    if (temPao && temFruta) return "Café com pão e fruta"
    if (temPao) return "Café com pão"
    if (temFruta) return "Café com fruta"
    return ""
}

// Café da manhã - funcionalidade nova (pedido do usuário, 2026-10-14), mesma
// tabela fpd061 do almoço (tipref='C' em vez de 'A'), mas SEM tipo de prato
// nem cardápio - "não tem escolhas, é só agendar ou cancelar e mostrar
// histórico igual tem no almoço" (palavras do usuário). Por isso é uma
// página própria mais enxuta, não um modo dentro da tela de Almoço.
export default function CafeManha() {

    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    const hoje = new Date().getDay();

    const converterDia = () => {
        if (hoje === 0) return 1;
        if (hoje === 6) return 1;
        return hoje;
    }

    // Mesma regra do almoço pra liberar a semana seguinte (confirmado pelo
    // usuário, 2026-10-14) - inclui sábado/domingo também (bug corrigido
    // 2026-10-24, ver Almoco/index.jsx pro comentário completo): sem isso a
    // liberação de sexta às 15h sumia nesse fim de semana.
    const podeVerProximaSemana = (hoje === 5 && new Date().getHours() >= 15) || hoje === 6 || hoje === 0;
    const [semanaSelecionada, setSemanaSelecionada] = useState("atual");

    const [diaSelecionado, setDiaSelecionado] = useState(converterDia());
    const [agendado, setAgendado] = useState(false);
    const [agendaSemana, setAgendaSemana] = useState([]);
    const [horaAgenda, setHoraAgenda] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [cancelado, setCancelado] = useState(false);
    const [dataCancelamento, setDataCancelamento] = useState("");
    const [logRef, setLogRef] = useState([]);

    // Composição do café (pão/fruta) - vai gravada no mesmo campo "nompra"
    // que o almoço usa pra "alteração de prato" (pedido do usuário,
    // 2026-10-15). Só 3 combinações possíveis, por isso checkbox em vez de
    // select - ver obterNompraCafe() pros textos exatos.
    const [pao, setPao] = useState(false);
    const [fruta, setFruta] = useState(false);

    // Prazo do café: pode agendar/cancelar em QUALQUER horário da véspera,
    // mas no dia da refeição (ou depois) já não dá mais - regra simplificada
    // (pedido do usuário, 2026-10-15; antes fechava às 20h da véspera, não
    // tem mais corte de hora nenhum). A trava de verdade é no backend
    // (PostRef/DelRef); isto aqui só evita mostrar botão que o servidor vai
    // recusar.
    function podeAgendarOuCancelar(dia) {

        if (semanaSelecionada === "proxima") return true

        return dia > converterDia()

    }

    function obterDataDiaSemana(dia) {

        const hoje = new Date()
        const diaAtual = hoje.getDay()
        const offsetSemana = semanaSelecionada === "proxima" ? 7 : 0
        const diff = dia - diaAtual + offsetSemana
        const data = new Date()
        data.setDate(hoje.getDate() + diff)
        return data.toLocaleDateString("pt-BR")

    }

    async function agendar() {

        try {

            if (!pao && !fruta) {
                alert("Escolha pelo menos uma opção: pão ou fruta.")
                return
            }

            const datref = obterDataDiaSemana(diaSelecionado)

            const payload = {
                codfun: user.codfun,
                tipfun: user.tipfun,
                datref: datref,
                tippra: "N", // café não tem escolha de tipo - valor fixo só pra satisfazer a coluna
                nompra: obterNompraCafe(pao, fruta),
                tipref: "C",
            }

            const res = await api.post("/colaborador/agendaref", payload)

            if (res.data?.result === "ERRO") {
                alert(res.data.msg || "Não foi possível agendar o café da manhã.")
                await carregarAgenda()
                return
            }

            await carregarAgenda()
            await carregarLogRef()

        }
        catch (err) {

            console.error(err)
            alert("Erro ao agendar café da manhã")

        }

    }

    function diaTemAgendamento(diaFront) {

        const diaApi = diaFront + 1
        const registro = agendaSemana.find(r => r.dia === diaApi)

        if (!registro) return false
        if (registro.status === "C" && !registro.datdes) return true

        return false

    }

    function diaJaPassou(dia = diaSelecionado) {
        return semanaSelecionada === "atual" && dia < converterDia()
    }

    function selecionarDia(dia) {
        setDiaSelecionado(dia)
        verificarDia(agendaSemana, dia)
    }

    function selecionarSemana(sem) {

        if (sem === semanaSelecionada) return
        if (sem === "proxima" && !podeVerProximaSemana) return

        const novoDia = sem === "proxima" ? 1 : converterDia()

        setSemanaSelecionada(sem)
        setDiaSelecionado(novoDia)
        carregarAgenda(sem, novoDia)

    }

    async function cancelar() {

        try {

            if (!navigator.onLine) {
                alert("Sem internet");
                return;
            }

            const datref = obterDataDiaSemana(diaSelecionado)

            const payload = {
                codfun: user.codfun,
                tipfun: user.tipfun,
                datref: datref,
                tipref: "C",
            }

            const res = await api.post("/colaborador/delref", payload)

            if (res.data?.result === "ERRO") {
                alert(res.data.msg || "Não foi possível cancelar o café da manhã.")
                await carregarAgenda()
                return
            }

            await carregarAgenda()
            await carregarLogRef()

        }
        catch (err) {

            console.error(err)
            alert("Erro ao cancelar café da manhã")

        }

    }

    function verificarDia(lista, diaFront) {

        const diaApi = diaFront + 1
        const registro = lista.find(r => r.dia === diaApi)

        if (!registro) {
            setAgendado(false)
            setCancelado(false)
            setHoraAgenda("")
            setPao(false)
            setFruta(false)
            return
        }

        // Reconstrói o estado dos checkboxes a partir do "nompra" já gravado,
        // pra exibir a escolha de quem já agendou (não dá pra reconstruir
        // perfeitamente se o texto não bater com nenhuma das 3 opções
        // conhecidas, mas nesse caso simplesmente fica sem nenhum marcado).
        const nompra = (registro.nompra || "").toLowerCase()
        setPao(nompra.includes("pão") || nompra.includes("pao"))
        setFruta(nompra.includes("fruta"))

        if (registro.datdes) {
            setCancelado(true)
            setAgendado(false)
            setDataCancelamento(registro.datdes)
            return
        }

        if (registro.status === "C") {
            setAgendado(true)
            setCancelado(false)
            setHoraAgenda(registro.datins)
        }
        else {
            setAgendado(false)
            setCancelado(false)
        }

    }

    async function carregarAgenda(semana = semanaSelecionada, dia = diaSelecionado) {

        const semanaParam = semana === "proxima" ? 1 : 0

        const res = await api.get(`/colaborador/getref/?codfun=${user.codfun}&tipfun=${user.tipfun}&semana=${semanaParam}&tipref=C`)

        setAgendaSemana(res.data)
        verificarDia(res.data, dia)

    }

    useEffect(() => {
        if (!agendaSemana.length) return
        verificarDia(agendaSemana, diaSelecionado)
    }, [diaSelecionado])

    useEffect(() => {
        if (!navigator.onLine) {
            alert("Sem internet");
            return;
        }
        carregarAgenda()
    }, [])

    async function carregarLogRef(dia = diaSelecionado) {

        try {

            const dataAlvo = obterDataDiaSemana(dia)

            const res = await api.get(`/colaborador/logref/?codfun=${user.codfun}&tipfun=${user.tipfun}&datref=${encodeURIComponent(dataAlvo)}&tipref=C`)

            setLogRef(Array.isArray(res.data) ? res.data : [])

        }
        catch (err) {

            console.error(err)
            setLogRef([])

        }

    }

    useEffect(() => {
        carregarLogRef()
    }, [diaSelecionado, semanaSelecionada])

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.header}>
                <button className={styles.btnVoltar} onClick={() => navigate("/refeicao")}><BackIcon /></button>
                <div className={styles.headerTexto}>
                    <h2>Café da Manhã</h2>
                    <p>Agendamento e acompanhamento</p>
                </div>
            </div>

            {/* SELEÇÃO DE DIA */}
            <div className={styles.card}>
                <div className={styles.cardTituloLinha}>
                    <span className={styles.cardTitulo}>📅 Selecione o dia{semanaSelecionada === "proxima" ? " — semana seguinte" : ""}</span>
                    <span className={styles.semanaRange}>{obterDataDiaSemana(1)} – {obterDataDiaSemana(5)}</span>
                </div>

                <div className={styles.semanaTabs}>
                    <button
                        className={`${styles.semanaTab} ${semanaSelecionada === "atual" ? styles.semanaTabAtivo : ""}`}
                        onClick={() => selecionarSemana("atual")}
                    >
                        Esta semana
                    </button>
                    <button
                        className={`${styles.semanaTab} ${semanaSelecionada === "proxima" ? styles.semanaTabAtivo : ""}`}
                        onClick={() => selecionarSemana("proxima")}
                        disabled={!podeVerProximaSemana}
                        title={podeVerProximaSemana ? undefined : "Libera às sextas-feiras, a partir das 15h"}
                    >
                        {!podeVerProximaSemana && "🔒 "}Semana seguinte
                    </button>
                </div>

                <div className={styles.diasGrid}>
                    {diasSemana.map((d) => {
                        const temAgenda = diaTemAgendamento(d.id)
                        const passado = diaJaPassou(d.id)
                        return (
                            <button
                                key={d.id}
                                onClick={() => selecionarDia(d.id)}
                                className={`${styles.diaCard} ${diaSelecionado === d.id ? styles.diaSelecionado : ""} ${passado ? styles.diaPassado : ""}`}
                            >
                                <span className={styles.diaNome}>{d.nome.slice(0, 3).toUpperCase()}</span>
                                {temAgenda && <span className={styles.badgeAgendado}>✓</span>}
                            </button>
                        )
                    })}
                </div>
            </div>

            {/* ESCOLHA DO CAFÉ (pão/fruta) */}
            <div className={styles.card}>
                <span className={styles.cardTitulo}>☕ O que vai no seu café?</span>
                <div className={styles.cafeOpcoes}>
                    <label className={styles.cafeOpcaoCheckbox}>
                        <input
                            type="checkbox"
                            checked={pao}
                            disabled={agendado || cancelado || diaJaPassou()}
                            onChange={(e) => setPao(e.target.checked)}
                        />
                        Pão
                    </label>
                    <label className={styles.cafeOpcaoCheckbox}>
                        <input
                            type="checkbox"
                            checked={fruta}
                            disabled={agendado || cancelado || diaJaPassou()}
                            onChange={(e) => setFruta(e.target.checked)}
                        />
                        Fruta
                    </label>
                </div>
            </div>

            {/* REGRAS DE HORÁRIO */}
            <div className={styles.regrasBox}>
                <strong className={styles.regrasTitulo}>Regras de agendamento:</strong>
                <ul className={styles.regrasLista}>
                    <li>Café da manhã: Agendamento ou cancelamento <strong>até a véspera</strong>, em qualquer horário.</li>
                    <li>No dia da refeição não é mais possível agendar nem cancelar.</li>
                    <li>Café da semana seguinte: Agendamento a partir de <strong>sexta-feira, às 15h</strong>.</li>
                </ul>
            </div>

            {/* STATUS / AÇÃO */}
            {cancelado ? (
                <div className={styles.canceladoBox}>
                    ❌ Cancelado em {dataCancelamento}
                </div>
            ) : agendado ? (
                <div className={styles.card}>
                    <div className={styles.statusBox}>
                        <span className={styles.statusIcone}>✅</span>
                        <div className={styles.statusTexto}>
                            <strong>Café da manhã agendado</strong>
                            <span>{horaAgenda}</span>
                        </div>
                    </div>
                    {podeAgendarOuCancelar(diaSelecionado) ? (
                        <ApiButton className={styles.btnCancelar} onClick={cancelar}>
                            Cancelar agendamento
                        </ApiButton>
                    ) : (
                        <p className={styles.avisoPrazoCancelar}>
                            🔒 Prazo para cancelar já expirou (só até a véspera).
                        </p>
                    )}
                </div>
            ) : diaJaPassou() ? (
                <p className={styles.avisoPrazoCancelar}>
                    Este dia já passou, sem agendamento registrado.
                </p>
            ) : (
                <button
                    className={styles.btnAgendar}
                    onClick={() => {
                        if (!podeAgendarOuCancelar(diaSelecionado)) {
                            alert("Prazo para agendamento expirado (só até a véspera)")
                            return
                        }
                        if (!pao && !fruta) {
                            alert("Escolha pelo menos uma opção: pão ou fruta.")
                            return
                        }
                        setShowConfirm(true)
                    }}
                >
                    Agendar Café da Manhã
                </button>
            )}

            {/* HISTÓRICO DO DIA */}
            {logRef.length > 0 && (
                <div className={styles.card}>
                    <span className={styles.cardTitulo}>🕘 Histórico do dia</span>
                    <div className={styles.logLista}>
                        {logRef.map((item, i) => {
                            const cancelou = item.acao === "CANCELADA"
                            return (
                                <div key={i} className={styles.logItem}>
                                    <span>{cancelou ? "❌" : "✅"}</span>
                                    <span>{cancelou ? "Cancelada" : "Agendada"} em {item.datahora}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}

            {/* MODAL CONFIRMAÇÃO */}
            {showConfirm && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalBox}>
                        <h3>Confirmar Agendamento</h3>
                        <p>
                            <strong>Café da manhã — {diasSemana.find(d => d.id === diaSelecionado)?.nome}</strong>
                            {semanaSelecionada === "proxima" ? " (semana seguinte)" : ""}
                        </p>
                        <p>{obterNompraCafe(pao, fruta)}</p>
                        <div className={styles.modalButtons}>
                            <button className={styles.btnCancelarModal} onClick={() => setShowConfirm(false)}>
                                Voltar
                            </button>
                            <ApiButton
                                className={styles.btnConfirmar}
                                onClick={() => { setShowConfirm(false); agendar() }}
                            >
                                Confirmar
                            </ApiButton>
                        </div>
                    </div>
                </div>
            )}

            <BottomNav />
        </div>
    )

}
